<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2>{{ 'BINARIES.TITLE' | translate }}</h2>
</div>

<div mat-dialog-content>
  <mat-card class="space-v-s">
    <mat-card-subtitle>{{ 'BINARIES.GENERATE_INSTRUCTION' | translate }}</mat-card-subtitle>
    <mat-card-content>
      <app-generate-binary-form
        [recipeOriginal]="recipeOriginal"
        [applianceGroupsRefData]="applianceGroupsRefData"
        [variants]="variants"
        [recipeDirty]="recipeDirty"
        (newBinaryHasBeenGenerated$)="newBinaryHasBeenGenerated$.emit()"
      ></app-generate-binary-form>
    </mat-card-content>
  </mat-card>

  <mat-card class="space-v-s">
    <mat-card-subtitle>{{ 'BINARIES.LIST_INSTRUCTIONS' | translate }}</mat-card-subtitle>
    <mat-card-content>
      <app-binaries-list
        [recipeOriginal]="recipeOriginal"
        [applianceGroupsRefData]="applianceGroupsRefData"
        [shouldReload$]="newBinaryHasBeenGenerated$"
      ></app-binaries-list>
    </mat-card-content>
  </mat-card>
</div>
